import React, { Component } from "react";
import { Container, Row, Col, Table } from "reactstrap";
import { CSVLink } from "react-csv";
import moment from "moment";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { Button, Form, Input, Alert, FormGroup, Label } from "reactstrap";
import { base_URL } from "../config/buildSettings.js";
import { apiKey } from "../config/index.js";
import { BounceLoader } from "react-spinners";
import { css } from "@emotion/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const options = {
  year: "numeric",
  month: "long",
  day: "numeric",
};

class NewKPI extends Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
    this.toggleMessageAlert = this.toggleMessageAlert.bind(this);
    this.toggleErrorAlert = this.toggleErrorAlert.bind(this);
    this.handleCalculate = this.handleCalculate.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getCurrentRound = this.getCurrentRound.bind(this);

    this.state = {
      data: {},
      currentRound: {},
      school_begin_date: moment("2024-01-01"),
      school_end_date: moment(),
      school_begin_dateFocused: false,
      school_end_dateFocused: false,
      useCurrentRoundDates: 'Yes',
      childcare_begin_date: moment().subtract(3, "years"),
      childcare_end_date: moment(),
      childcare_begin_dateFocused: false,
      childcare_end_dateFocused: false,
      useCurrentRoundDatesChildCare: 'Yes',
      currentRoundLoading: true,
      loading: false,
      report: "",
      error: "",
      message: "",
      showMessageAlert: false,
      showErrorAlert: false,
      isTest: false,
      isInternal: false,
    };
  }

  componentDidMount() {
    this.getCurrentRound();
  }

  toggleErrorAlert() {
    this.setState({
      showErrorAlert: !this.state.showErrorAlert,
      error: "",
    });
  }

  toggleMessageAlert() {
    this.setState({
      showMessageAlert: !this.state.showMessageAlert,
      message: "",
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }


  getCurrentRound() {
    let url;
    url = `${base_URL}/api/internal/getround`;

    console.log(url);

    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        apiKey: apiKey
      })
    })
      .then(response => {
        console.log(response);
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        var old = JSON.stringify(json).replaceAll('T00:00:00', ''); //convert to JSON string
        var newArray = JSON.parse(old); //convert back to array
        this.setState({
          currentRound: newArray,
          currentRoundLoading: false
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({ error: error.message, showErrorAlert: true, warn: false, currentRoundLoading: false });
      });
  }

  handleCalculate(event) {
    event.preventDefault();

    this.fetchData();
  }

  fetchData(event) {
    this.setState({ loading: true });
    let url, useCredentials;

    url = `${base_URL}/api/internal/newpublickpi`;
    useCredentials = "include";

    // console.log(url);
    fetch(url, {
      method: "POST",
      credentials: useCredentials,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        apiKey: apiKey,
        school_begin_date: this.state.useCurrentRoundDates === "No" ? this.state.school_begin_date : null,
        school_end_date: this.state.useCurrentRoundDates === "No" ? this.state.school_end_date : null,
        childcare_begin_date: this.state.useCurrentRoundDatesChildCare === "No" ? this.state.childcare_begin_date : null,
        childcare_end_date: this.state.useCurrentRoundDatesChildCare === "No" ? this.state.childcare_end_date : null,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((json) => {
        if (!json || json.length === 0) {
          let message;
          message = "No Data Found";
          this.setState({
            message: message,
            showMessageAlert: true,
            data: {},
            loading: false,
          });

          return;
        }
        var old = JSON.stringify(json).replaceAll('T00:00:00', ''); //convert to JSON string
        var newArray = JSON.parse(old); //convert back to array

        this.setState({ data: newArray, loading: false });
      })
      .catch((error) => {
        this.setState({
          error: error.message,
          showErrorAlert: true,
          data: {},
          loading: false,
        });
      });
  }

  render() {
    return (
      this.state.currentRoundLoading === false && (
        <span>
          <Container>
            <Form onSubmit={this.handleCalculate}>
              <Row form>
                <Col
                  md={{ size: 3 }}
                  lg={{ size: 3 }}
                  xl={{ size: 3 }}
                  style={{ marginBottom: "1rem", display: "flex", justifyContent: "center" }}
                >
                  <FormGroup style={{ textAlign: "center" }}>
                    <Label for="useCurrentRoundDates">Use current round for schools?</Label>
                    <br />
                    <Input
                      type="select"
                      name="useCurrentRoundDates"
                      id="useCurrentRoundDates"
                      value={this.state.useCurrentRoundDates}
                      onChange={this.handleInputChange}
                      style={{
                        marginTop: "0.5rem",
                        minWidth: "9rem",
                        fontSize: "1.05rem",
                        textAlign: "center",
                      }}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Input>
                  </FormGroup>
                </Col>
                {this.state.useCurrentRoundDates === "Yes" && this.state.currentRound[0] && (
                  <Col
                    md={{ size: 5 }}
                    lg={{ size: 5 }}
                    xl={{ size: 5 }}
                    style={{ marginBottom: "1rem" }}>
                    <span>Current Round: <strong>{this.state.currentRound[0].Round_Name}</strong> ({moment(this.state.currentRound[0].Round_Begin).format("M/D/YYYY")} to {moment(this.state.currentRound[0].Round_End).format("M/D/YYYY")})</span>
                  </Col>

                )}
                {this.state.useCurrentRoundDates === "No" && (
                  <>
                    <Col
                      md={{ size: 3 }}
                      lg={{ size: 3 }}
                      xl={{ size: 3 }}
                      style={{ marginBottom: "1rem" }}
                    >
                      <FormGroup>
                        <Label for="schoolBeginDateInput">School Sampling Begin Date</Label>
                        <br />
                        <SingleDatePicker
                          date={this.state.school_begin_date}
                          onDateChange={(school_begin_date) =>
                            this.setState({ school_begin_date: school_begin_date, data: {} })
                          }
                          focused={this.state.school_begin_dateFocused}
                          onFocusChange={({ focused }) =>
                            this.setState({ school_begin_dateFocused: focused })
                          }
                          isOutsideRange={(day) => false}
                          renderMonthElement={renderMonthElement}
                          numberOfMonths={1}
                          id="schoolBeginDateInput"
                          block={true}
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      md={{ size: 3 }}
                      lg={{ size: 3 }}
                      xl={{ size: 3 }}
                      style={{ marginBottom: "1rem" }}
                    >
                      <FormGroup>
                        <Label for="schoolEndDateInput">School Sampling End Date</Label>
                        <br />
                        <SingleDatePicker
                          date={this.state.school_end_date}
                          onDateChange={(school_end_date) =>
                            this.setState({ school_end_date: school_end_date, data: {} })
                          }
                          focused={this.state.school_end_dateFocused}
                          onFocusChange={({ focused }) =>
                            this.setState({ school_end_dateFocused: focused })
                          }
                          isOutsideRange={(day) => false}
                          renderMonthElement={renderMonthElement}
                          numberOfMonths={1}
                          id="schoolEndDateInput"
                          block={true}
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>
              <Row form>
                <Col
                  md={{ size: 3 }}
                  lg={{ size: 3 }}
                  xl={{ size: 3 }}
                  style={{ marginBottom: "1rem", display: "flex", justifyContent: "center" }}
                >
                  <FormGroup style={{ textAlign: "center" }}>
                    <Label for="useCurrentRoundDatesChildCare">Use current round for child cares?</Label>
                    <br />
                    <Input
                      type="select"
                      name="useCurrentRoundDatesChildCare"
                      id="useCurrentRoundDatesChildCare"
                      value={this.state.useCurrentRoundDatesChildCare}
                      onChange={this.handleInputChange}
                      style={{
                        marginTop: "0.5rem",
                        minWidth: "9rem",
                        fontSize: "1.05rem",
                        textAlign: "center",
                      }}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Input>
                  </FormGroup>
                </Col>
                {this.state.useCurrentRoundDatesChildCare === "Yes" && (
                  <Col
                    md={{ size: 5 }}
                    lg={{ size: 5 }}
                    xl={{ size: 5 }}
                    style={{ marginBottom: "1rem" }}>
                    <span>Current Round: <strong>Last 3 Years</strong> ({moment(this.state.childcare_begin_date).format("M/D/YYYY")} to {moment(this.state.childcare_end_date).format("M/D/YYYY")})</span>
                  </Col>
                )}
                {this.state.useCurrentRoundDatesChildCare === "No" && (
                  <>
                    <Col
                      md={{ size: 3 }}
                      lg={{ size: 3 }}
                      xl={{ size: 3 }}
                      style={{ marginBottom: "1rem" }}
                    >
                      <FormGroup>
                        <Label for="childcareBeginDateInput">Child Care Sampling Begin Date</Label>
                        <br />
                        <SingleDatePicker
                          date={this.state.childcare_begin_date}
                          onDateChange={(childcare_begin_date) =>
                            this.setState({ childcare_begin_date: childcare_begin_date, data: {} })
                          }
                          focused={this.state.childcare_begin_dateFocused}
                          onFocusChange={({ focused }) =>
                            this.setState({ childcare_begin_dateFocused: focused })
                          }
                          isOutsideRange={(day) => false}
                          renderMonthElement={renderMonthElement}
                          numberOfMonths={1}
                          id="childcareBeginDateInput"
                          block={true}
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      md={{ size: 3 }}
                      lg={{ size: 3 }}
                      xl={{ size: 3 }}
                      style={{ marginBottom: "1rem" }}
                    >
                      <FormGroup>
                        <Label for="childcareEndDateInput">Child Care Sampling End Date</Label>
                        <br />
                        <SingleDatePicker
                          date={this.state.childcare_end_date}
                          onDateChange={(childcare_end_date) =>
                            this.setState({ childcare_end_date: childcare_end_date, data: {} })
                          }
                          focused={this.state.childcare_end_dateFocused}
                          onFocusChange={({ focused }) =>
                            this.setState({ childcare_end_dateFocused: focused })
                          }
                          isOutsideRange={(day) => false}
                          renderMonthElement={renderMonthElement}
                          numberOfMonths={1}
                          id="childcareEndDateInput"
                          block={true}
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                <Col
                  md={{ size: 3 }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Button type="submit" color="primary">
                    Calculate
                  </Button>
                </Col>
              </Row>
              <br />
            </Form>
            <Container style={{ textAlign: "center" }}>
              <Row>
                <Col>
                  <span className="login-spinner">
                    <BounceLoader
                      size={60}
                      sizeUnit={"px"}
                      color={"#36D7B7"}
                      css={override}
                      loading={this.state.loading}
                    />
                  </span>
                  {this.state.error !== "" && (
                    <Alert
                      color="warning"
                      isOpen={this.state.showErrorAlert}
                      toggle={this.toggleErrorAlert}
                    >
                      {this.state.error}
                    </Alert>
                  )}
                  {this.state.message !== "" && (
                    <Alert
                      color="info"
                      isOpen={this.state.showMessageAlert}
                      toggle={this.toggleMessageAlert}
                    >
                      {this.state.message}
                    </Alert>
                  )}
                </Col>
              </Row>
              <Row>
                {!this.state.loading && this.state.data && this.state.data.length > 0 && (
                  <>
                    <Col xl={{ size: "10", offset: "1" }}>
                      <span>
                        <span className="h4">
                          {this.state.useCurrentRoundDates === "Yes"
                            ? `Current testing status for schools: Round ${this.state.currentRound[0].Round_Name} (${moment(this.state.currentRound[0].Round_Begin).format("M/D/YYYY")} - ${moment(this.state.currentRound[0].Round_End).format("M/D/YYYY")})`
                            : `Current testing status for schools: ${moment(this.state.school_begin_date).format("M/D/YYYY")} - ${moment(this.state.school_end_date).format("M/D/YYYY")}`}
                        </span>
                        <br />
                        <span>
                          Testing occurs every three years. For more information, visit{" "}
                          <a href="https://www.HealthVermont.gov/LeadTesting" target="_blank" rel="noopener noreferrer">
                            www.HealthVermont.gov/LeadTesting
                          </a>
                          .
                        </span>
                        <br />
                        <br />
                        <Table bordered className="kpi-table">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left" }}>Category</th>
                              <th style={{ textAlign: "right" }}>Number</th>
                              <th style={{ textAlign: "left" }}>
                                Percent of Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.data.filter((datum) => datum.Section === "Schools").map(
                              (datum) =>
                                datum.Sequence && (
                                  <tr key={datum.Sequence}>
                                    <td style={{ textAlign: "left" }}>
                                      {datum.Sequence + ". " + datum.Indicator}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {Number(datum.Count).toLocaleString(
                                        "EN-us"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {!datum.Denominator.includes("N/A")
                                        ? parseFloat(datum.Rate * 100).toFixed(
                                          0
                                        ) +
                                        "% " +
                                        datum.Denominator
                                        : datum.Denominator}
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Table>
                        {/* Child Cares */}
                        <br />
                        <br />
                        <span className="h4">
                          {this.state.useCurrentRoundDatesChildCare === "Yes"
                            ? `Current testing status for child cares: Last 3 Years (${moment(this.state.childcare_begin_date).format("M/D/YYYY")} - ${moment(this.state.childcare_end_date).format("M/D/YYYY")})`
                            : `Current testing status for child cares: ${moment(this.state.childcare_begin_date).format("M/D/YYYY")} - ${moment(this.state.childcare_end_date).format("M/D/YYYY")}`}
                        </span>
                        <br />
                        <br />
                        <Table bordered className="kpi-table">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left" }}>Category</th>
                              <th style={{ textAlign: "right" }}>Number</th>
                              <th style={{ textAlign: "left" }}>
                                Percent of Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.data.filter((datum) => datum.Section === "Child Cares").map(
                              (datum) =>
                                datum.Sequence && (
                                  <tr key={datum.Sequence}>
                                    <td style={{ textAlign: "left" }}>
                                      {datum.Sequence + ". " + datum.Indicator}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {Number(datum.Count).toLocaleString(
                                        "EN-us"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {!datum.Denominator.includes("N/A")
                                        ? parseFloat(datum.Rate * 100).toFixed(
                                          0
                                        ) +
                                        "% " +
                                        datum.Denominator
                                        : datum.Denominator}
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Table>

                        {/* Totals */}
                        <br />
                        <br />
                        <span className="h4">
                          Totals for schools and child cares combined: (latest round of testing for each tap)
                        </span>
                        <br />
                        <br />
                        <Table bordered className="kpi-table">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left" }}>Category</th>
                              <th style={{ textAlign: "right" }}>Number</th>
                              <th style={{ textAlign: "left" }}>
                                Percent of Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.data.filter((datum) => datum.Section === "Totals").map(
                              (datum) =>
                                datum.Sequence && (
                                  <tr key={datum.Sequence}>
                                    <td style={{ textAlign: "left" }}>
                                      {datum.Sequence + ". " + datum.Indicator}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {Number(datum.Count).toLocaleString(
                                        "EN-us"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {!datum.Denominator.includes("N/A")
                                        ? parseFloat(datum.Rate * 100).toFixed(
                                          0
                                        ) +
                                        "% " +
                                        datum.Denominator
                                        : datum.Denominator}
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Table>
                      </span>
                    </Col>
                  </>
                )}
              </Row>
            </Container>
          </Container>
        </span>
      )
    );
  }
}

export default NewKPI;

const returnYears = () => {
  let years = [];
  for (let i = moment().year() - 15; i <= moment().year() + 1; i++) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  return years;
};

const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.month()}
        onChange={(e) => onMonthSelect(month, e.target.value)}
      >
        {moment.months().map((label, value) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Input>
    </div>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.year()}
        onChange={(e) => onYearSelect(month, e.target.value)}
      >
        {returnYears()}
      </Input>
    </div>
  </div>
);
